import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PairingCodeResult } from './pairing-code.model';

@Injectable()
export class PairingCodeResource {
    private readonly baseUrl: string = '/services/apic-pairing-code/api';
    private readonly apiKey: string = '{<APIC-PAIRING-CODE-API-KEY>}';

    private readonly httpClient: HttpClient = inject(HttpClient);

    private get headers(): HttpHeaders {
        return new HttpHeaders().set('X-Api-Key', this.apiKey);
    }

    public getPairingCodeResultaat(pairingCode: string): Observable<PairingCodeResult> {
        return this.httpClient.post<PairingCodeResult>(
            `${this.baseUrl}/pairing-codes/client-values`,
            {
                pairing_code: pairingCode
            },
            {
                headers: this.headers
            }
        );
    }
}
